module.exports = __webpack_public_path__ + "img/box_bg8.e2489ab.png";